import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './core/services/analytics.service';
import { FirebaseService } from './core/services/firebase.service';
import { NotificationService } from './core/services/notification.service';
import { Capacitor } from '@capacitor/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { StorageKey, StorageService } from './core/services/storage.service';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AnalyticsDataOpenApp } from './core/types/analytics';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  showNav: boolean = false;

  constructor(
    private analyticsService: AnalyticsService,
    private firebaseService: FirebaseService,
    private notificationService: NotificationService,
    private router: Router,
    private storageService: StorageService,
    private angularFireAuth: AngularFireAuth,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      // This is a bit of a hack to hide the nav on the activation route.
      this.showNav = !this.router.url.startsWith('/activation');
    });
  }

  ngOnInit() {
    this.storageService.set(StorageKey.NOTIFICATION_TIMER, new Date());
    this.firebaseService.anonymousLogin();

    this.updateLastActivity();
    this.angularFireAuth.user.subscribe(async (user) => {
      if (!user.uid) return;
      await this.analyticsService.pushAnalyticsEvent<AnalyticsDataOpenApp>({
        event: 'openApp',
        userId: user.uid,
      });
    });

    this.notificationService.requestPermission();

    // The capacitor push notification plugin is not supported on web.
    if (Capacitor.getPlatform() !== 'web') {
      this.notificationService.initPushNotifications().then();
      ScreenOrientation.lock({ orientation: 'portrait' }).then();
    }
  }

  updateLastActivity() {
    this.analyticsService.updateLastActive().then();
  }
}
